(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "prop-types", "react", "./formField"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("prop-types"), require("react"), require("./formField"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.propTypes, global.react, global.formField);
    global.SortField = mod.exports;
  }
})(this, function (_exports, _propTypes, _react, _formField) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports["default"] = _exports.SortFieldRaw = void 0;
  _propTypes = _interopRequireDefault(_propTypes);
  _react = _interopRequireDefault(_react);
  _formField = _interopRequireDefault(_formField);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

  function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

  function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

  function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

  function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

  function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

  function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

  function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

  function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

  function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function swap(items, oldIndex, newIndex) {
    return items.set(oldIndex, items.get(newIndex)).set(newIndex, items.get(oldIndex));
  }

  var SortFieldRaw =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(SortFieldRaw, _React$Component);

    function SortFieldRaw() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, SortFieldRaw);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SortFieldRaw)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "state", {
        dragIndex: null,
        dropIndex: null
      });

      return _this;
    }

    _createClass(SortFieldRaw, [{
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props = this.props,
            value = _this$props.value,
            onChange = _this$props.onChange,
            name = _this$props.name,
            scopedName = _this$props.scopedName,
            children = _this$props.children,
            onReorder = _this$props.onReorder,
            validate = _this$props.validate,
            disabled = _this$props.disabled,
            orientation = _this$props.orientation,
            itemSize = _this$props.itemSize,
            crossAxisItemSize = _this$props.crossAxisItemSize,
            itemCount = _this$props.itemCount,
            itemSpacing = _this$props.itemSpacing,
            other = _objectWithoutProperties(_this$props, ["value", "onChange", "name", "scopedName", "children", "onReorder", "validate", "disabled", "orientation", "itemSize", "crossAxisItemSize", "itemCount", "itemSpacing"]);

        var _this$state = this.state,
            dragIndex = _this$state.dragIndex,
            dropIndex = _this$state.dropIndex;
        var dimension = orientation === 'horizontal' ? {
          width: itemSize * itemCount + itemSpacing * (itemCount - 1),
          height: crossAxisItemSize
        } : {
          height: itemSize * itemCount + itemSpacing * (itemCount - 1),
          width: crossAxisItemSize
        };
        return _react["default"].createElement("div", _extends({}, other, {
          style: _objectSpread({
            position: 'relative'
          }, dimension)
        }), value.map(function (item, index) {
          var itemWithDndInfo = item.set('__isSource', dragIndex === index).set('__isTarget', dropIndex === index).set('__isDragging', dragIndex !== null).set('__isDisabled', disabled(item, index, value));
          var itemPosition = orientation === 'horizontal' ? {
            left: index * (itemSize + itemSpacing),
            top: 0
          } : {
            top: index * (itemSize + itemSpacing),
            left: 0
          };
          var itemDimension = orientation === 'horizontal' ? {
            width: itemSize,
            height: crossAxisItemSize
          } : {
            height: itemSize,
            width: crossAxisItemSize
          };
          return _react["default"].createElement("div", {
            key: index,
            draggable: true,
            style: _objectSpread({
              position: 'absolute'
            }, itemPosition, {}, itemDimension),
            onDragStart: function onDragStart(event) {
              if (!itemWithDndInfo.get('__isDisabled')) {
                if (event.dataTransfer) event.dataTransfer.setData('Url', '#');

                _this2.setState({
                  dragIndex: index
                });
              } else {
                event.preventDefault();
              }
            },
            onDragEnd: function onDragEnd() {
              _this2.setState({
                dragIndex: null
              });
            },
            onDragEnter: function onDragEnter() {
              if (dragIndex !== null && dragIndex !== index && validate(swap(value, dragIndex, index))) {
                _this2.setState({
                  dropIndex: index
                });
              }
            },
            onDragOver: function onDragOver(event) {
              if (!itemWithDndInfo.get('__isDisabled') && dragIndex !== null && dragIndex !== index && validate(swap(value, dragIndex, index))) {
                event.preventDefault();
              }
            },
            onDragLeave: function onDragLeave() {
              if (dropIndex === index) {
                _this2.setState({
                  dropIndex: null
                });
              }
            },
            onDrop: function onDrop(event) {
              event.preventDefault();

              _this2.setState({
                dragIndex: null,
                dropIndex: null
              });

              _this2.props.onReorder(dragIndex, index);

              onChange(swap(value, dragIndex, index));
            }
          }, children(itemWithDndInfo, index, value));
        }));
      }
    }]);

    return SortFieldRaw;
  }(_react["default"].Component);

  _exports.SortFieldRaw = SortFieldRaw;

  _defineProperty(SortFieldRaw, "propTypes", {
    value: _propTypes["default"].any.isRequired,
    onChange: _propTypes["default"].func.isRequired,
    name: _propTypes["default"].string,
    scopedName: _propTypes["default"].string,
    children: _propTypes["default"].func.isRequired,
    onReorder: _propTypes["default"].func,
    validate: _propTypes["default"].func,
    disabled: _propTypes["default"].func,
    orientation: _propTypes["default"].oneOf(['horizontal', 'vertical']).isRequired,
    itemSize: _propTypes["default"].number.isRequired,
    crossAxisItemSize: _propTypes["default"].number.isRequired,
    itemSpacing: _propTypes["default"].number,
    itemCount: _propTypes["default"].number.isRequired
  });

  _defineProperty(SortFieldRaw, "defaultProps", {
    onReorder: function onReorder() {
      return null;
    },
    validate: function validate() {
      return true;
    },
    disabled: function disabled() {
      return false;
    },
    itemSpacing: 0
  });

  var _default = (0, _formField["default"])()(SortFieldRaw);

  _exports["default"] = _default;
});